
  (() => {
    const fonts = [
      '"Monotype Corsiva", "URW Chancery L", cursive', 'Allison, cursive',
      'Anttolla, cursive', '"Beauty Script", cursive', '"Bell MT", "Times New Roman", serif',
      '"Blow Up", Blowup, sans-serif', 'Century, "Century Schoolbook", Georgia, serif',
      '"Copperplate Gothic", "Copperplate Gothic Bold", Copperplate, serif',
      '"Imprint MT", "Imprint MT Shadow", Georgia, serif', 'Nattalia, cursive',
      '"Reinata Script", Reinata, cursive'
    ];
    const initialized = new WeakSet();
    const initialize = (root) => {
      if (initialized.has(root)) return;
      initialized.add(root);
      const name = root.querySelector('[data-name-input]');
      const title = root.querySelector('[data-title-input]');
      const plate = root.querySelector('[data-plate-input]');
      const font = root.querySelector('[data-font-input]');
      const preview = root.querySelector('[data-plate-preview]');
      const previewName = root.querySelector('[data-name-preview]');
      const previewTitle = root.querySelector('[data-title-preview]');
      const combined = root.querySelector('[data-combined-property]');
      const dialog = root.querySelector('dialog');
      const opener = root.querySelector('.go-personal-open');
      const note = root.querySelector('[data-personal-note]');
      const skipButtons = root.querySelectorAll('[data-plate-skip]');
      let skipValue = '';

      const decided = () => name.value.trim() || skipValue;
      const close = () => { root.dataset.pendingAdd = ''; note.hidden = true; dialog.close(); opener.focus(); };
      root.querySelector('.go-personal-close').addEventListener('click', close);
      dialog.addEventListener('cancel', () => { root.dataset.pendingAdd = ''; note.hidden = true; });
      root.querySelector('.go-personal-save').addEventListener('click', () => {
        sync();
        if (!decided()) {
          note.hidden = false;
          name.focus();
          return;
        }
        note.hidden = true;
        root.dataset.pendingAdd = '';
        const form = root.closest('form');
        const submitter = form?.querySelector('button[type="submit"][name="add"]');
        dialog.close();
        if (form) {
          requestAnimationFrame(() => {
            form.requestSubmit(submitter || undefined);
          });
        }
      });
      const choices = root.querySelector('[data-go-font-choices]');
      choices.replaceChildren();
      Array.from(font.options).forEach(option => {
        const button = document.createElement('button'); button.type = 'button'; button.dataset.font = option.value;
        const sample = document.createElement('span'); sample.textContent = root.dataset.nameSample; sample.style.fontFamily = fonts[Number(option.value)-1];
        const label = document.createElement('small'); label.textContent = option.textContent;
        button.append(sample, label); button.addEventListener('click', () => { font.value=option.value; font.dispatchEvent(new Event('input',{bubbles:true})); }); choices.append(button);
      });
      root.querySelectorAll('[data-go-plate]').forEach(button => button.addEventListener('click', () => { plate.value=button.dataset.goPlate; plate.dispatchEvent(new Event('input',{bubbles:true})); }));
      skipButtons.forEach(button => button.addEventListener('click', () => {
        skipValue = button.dataset.plateSkip;
        name.value = '';
        title.value = '';
        note.hidden = true;
        sync();
      }));
      const sync = () => {
        const nameText = name.value.trim();
        if (nameText) skipValue = '';
        root.querySelectorAll('[data-go-plate]').forEach(b => b.setAttribute('aria-pressed',String(b.dataset.goPlate===plate.value)));
        skipButtons.forEach(b => b.setAttribute('aria-pressed', String(!nameText && b.dataset.plateSkip === skipValue)));
        choices.querySelectorAll('button').forEach(b => { b.setAttribute('aria-pressed',String(b.dataset.font===font.value)); b.querySelector('span').textContent=nameText || root.dataset.nameSample; });
        const titleText = title.value.trim();
        combined.value = nameText ? [nameText, titleText].filter(Boolean).join(' / ') : skipValue;
        previewName.textContent = nameText || [...skipButtons].find(b => b.dataset.plateSkip === skipValue)?.textContent || root.dataset.nameSample;
        previewTitle.textContent = titleText;
        preview.dataset.color = plate.value === 'Gümüş' ? 'silver' : 'gold';
        const family = fonts[Number(font.value) - 1] || 'serif';
        previewName.style.fontFamily = family;
        previewTitle.style.fontFamily = family;
      };
      [name, title, plate, font].forEach((input) => input.addEventListener('input', sync));
      sync();
    };
    const openDialog = (root, fromCart) => {
      initialize(root);
      const dialog = root.querySelector('dialog');
      const note = root.querySelector('[data-personal-note]');
      if (fromCart) {
        root.dataset.pendingAdd = 'true';
        note.hidden = false;
      } else {
        note.hidden = true;
      }
      if (!dialog.open) dialog.showModal();
      root.querySelector('[data-name-input]')?.focus();
    };
    document.addEventListener('click', event => {
      const opener = event.target.closest('.go-personal-open');
      if (!opener) return;
      const root = opener.closest('[data-guner-personalization]');
      openDialog(root, false);
    });
    document.addEventListener('guner:open-plate', event => {
      const root = event.target;
      if (!(root instanceof HTMLElement) || !root.matches('[data-guner-personalization]')) return;
      openDialog(root, true);
    });
    document.querySelectorAll('[data-guner-personalization]').forEach((root) => {
      if (root.dataset.pendingAdd === 'true') openDialog(root, true);
    });
  })();


